import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const MainContainer = ({ children, header }) => {
  return (
    <Container
      className='py-5 d-print-block'
      style={{
        backgroundColor: 'white',
        boxShadow: '0 0 5px 0.1px #ccc',
        borderRadius: '5px',
        overflowX: 'hidden',
      }}
    >
      <Row className='justify-content-md-center'>
        <Col xs={12} md={8}>
          {header}
        </Col>
      </Row>
      {header && <hr className='mb-5' />}
      <Row className='justify-content-md-center'>
        <Col xs={12} md={8}>
          {children}
        </Col>
      </Row>
    </Container>
  );
};

export default MainContainer;
